import { render } from "./ClientTabNav.vue?vue&type=template&id=0e7b1f78"
import script from "./ClientTabNav.vue?vue&type=script&lang=js"
export * from "./ClientTabNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__